import { type FlowAgentState } from 'flow-schema';

import { type BaseItem } from '../common.js';

export enum AgentCategory {
  Rcm = 'Rcm',
  Placeholder = 'Placeholder',
  Authorization = 'Authorization',
  CallCenter = 'CallCenter',
  ChartScrubbing = 'ChartScrubbing',
  ClinicalTrials = 'ClinicalTrials',
  FrontDesk = 'FrontDesk',
  InpatientCare = 'InpatientCare',
  MedicationAdherence = 'MedicationAdherence',
  Patient = 'Patient',
  PatientCare = 'PatientCare',
  Quality = 'Quality',
  Referrals = 'Referrals',
}

interface BaseAgent {
  name: string;
  description?: string;
  organizationId: string;
  category: AgentCategory;
  state?: FlowAgentState;
}

export type CreateValues = BaseAgent;
export type UpdateAgentValues = Partial<Omit<BaseAgent, 'organizationId'>>;

export interface Agent extends BaseAgent, BaseItem {}

export interface FindAllOptions {
  q?: string;
  organizationId?: string | string[];
  limit?: number;
  offset?: number;
  orderBy?: string;
  orderDirection?: 'asc' | 'desc';
}

export interface FlowStat {
  name: string;
  value: string;
}
